import React, { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  ListItemButton,
  ListItem,
  Button,
} from "@mui/material";
import { BarChart as BarChartIcon, Users as UsersIcon } from "react-feather";
import NavItem from "./NavItem";
import NavItemdropdown from "./NavItemdropdown";
import Billingdropdown from "./Billingdropdown";
import AssignLabDropdown from "./AssignLabDropdown";
import UserManagementDropdown from "./UserManagementDropdown";
import AssessmentDropdown from "./AssessmentDropdown";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import AppsIcon from "@mui/icons-material/Apps";
import ImageIcon from "@mui/icons-material/Image";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Collapse from "@mui/material/Collapse";

const user = {
  avatar: "/static/images/avatars/zippy.png",
  email: localStorage.getItem("email"),
  name: localStorage.getItem("user"),
};

if (localStorage.getItem("group") === "admin") {
  var items = [
    {
      id: "Labs",
      title: "Labs",
      type: "group",
      children: [
        {
          icon: ImageIcon,
          title: "LabList",
        },
      ],
    },
    {
      id: "Management",
      title: "Management",
      type: "group",
      children: [
        {
          title: "UserManagement",
        },
        // {
        //   href: "/app/management",
        //   icon: UsersIcon,
        //   title: "UserManagement",
        // },
        {
          title: "Assign Labs",
        },
        {
          // href: "/app/quiztable",
          title: "Assessment",
        },
        {
          title: "Billing Information",
        },
        {
          href: "/app/estimation",
          icon: AppsIcon,
          title: "Lab Estimation",
        },
        {
          href: "/app/judge",
          icon: UsersIcon,
          title: "Code Compiler",
        },
        {
          href: "/app/adminfeedback",
          icon: UsersIcon,
          title: "Feedback",
        },
      ],
    },
    {
      id: "Settings",
      title: "Settings",
      type: "group",
      children: [
        {
          href: "/app/profile",
          icon: PersonPinIcon,
          title: "Profile",
        },
        {
          href: "/app/connectivitycheck",
          title: "Connectivity Test",
        },
        {
          href: "/app/about",
          title: "About",
        },
        {
          href: "https://support.zippyops.com",
          icon: HeadsetMicIcon,
          title: "Support",
        },
        {
          href: "https://docs.labasservice.com",
          title: "Docs",
        },
      ],
    },
  ];
} else if (localStorage.getItem("group") === "ops_users") {
  var items = [
    {
      id: "Labs",
      title: "Labs",
      type: "group",
      children: [
        {
          icon: ImageIcon,
          title: "LabList",
        },
      ],
    },

    {
      id: "Management",
      title: "Management",
      type: "group",
      children: [
        {
          href: "/app/estimation",
          icon: AppsIcon,
          title: "Lab Estimation",
        },
        {
          title: "Billing Information",
        },
      ],
    },
    {
      id: "Settings",
      title: "Settings",
      type: "group",
      children: [
        {
          href: "/app/profile",
          icon: PersonPinIcon,
          title: "Profile",
        },
        {
          href: "/app/about",
          title: "About",
        },
        {
          href: "https://support.zippyops.com",
          icon: HeadsetMicIcon,
          title: "Support",
        },
        {
          href: "https://docs.labasservice.com",
          title: "Docs",
        },
      ],
    },
  ];
} else {
  var items = [
    {
      id: "Labs",
      title: "Labs",
      type: "group",
      children: [
        {
          title: "LabList",
        },
      ],
    },
    {
      id: "Management",
      title: "Management",
      type: "group",
      children: [
        {
          href: "/app/estimation",
          icon: AppsIcon,
          title: "Lab Estimation",
        },
      ],
    },
    {
      id: "Settings",
      title: "Settings",
      type: "group",
      children: [
        {
          href: "/app/profile",
          icon: PersonPinIcon,
          title: "Profile",
        },
        {
          href: "/app/about",
          title: "About",
        },
        {
          href: "https://support.zippyops.com",
          icon: HeadsetMicIcon,
          title: "Support",
        },
        {
          href: "https://docs.labasservice.com",
          title: "Docs",
        },
      ],
    },
  ];
}

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const splitLoc = splitLocation[3];
  const splitLoc1 = splitLocation[2];
  // console.log(splitLocation[3])

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box sx={{ p: 2 }}>
        <List>
          <div>
            <li className="px-3 rounded-lg mb-1 text-gray-700">
              <NavItem
                href="/app/dashboard"
                key="Dashboard" // Unique key for this element
                title="Dashboard"
                icon={BarChartIcon}
                style={{ paddingTop: "3px" }}
              />
            </li>
          </div>
  
          {items.map((item, itemIndex) => (
            <div key={itemIndex}> {/* Added key for this top-level div */}
              <Typography
                color="white"
                variant="caption"
                display="block"
                style={{ paddingTop: "7px" }}
              >
                {item.title}
              </Typography>
              <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
              {item.children.map((child, childIndex) => (
                <li
                  key={`${item.title}-${child.title}-${childIndex}`} // Unique key combining parent and child properties
                  className="px-3 rounded-lg mb-1 text-gray-700"
                >
                  {child.title === "LabList" ? (
                    <NavItemdropdown style={{ paddingTop: "3px" }} />
                  ) : child.title === "UserManagement" ? (
                    <UserManagementDropdown style={{ paddingTop: "3px" }} />
                  ) : child.title === "Assign Labs" ? (
                    <AssignLabDropdown style={{ paddingTop: "3px" }} />
                  ) : child.title === "Billing Information" ? (
                    <Billingdropdown style={{ paddingTop: "3px" }} />
                  ) : child.title === "Assessment" ? (
                    <AssessmentDropdown style={{ paddingTop: "3px" }} />
                  ) : (
                    <NavItem
                      href={child.href}
                      key={child.title} // Key for NavItem
                      title={child.title}
                      icon={child.icon}
                      title1={item.title}
                      style={{ paddingTop: "3px" }}
                    />
                  )}
                </li>
              ))}
            </div>
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      
      {/* Copyright Footer */}
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          borderTop: '1px solid',
          borderColor: 'rgba(255, 255, 255, 0.12)'
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem'
          }}
        >
          © {new Date().getFullYear()} ZippyOPS Consulting Services LLP.
        </Typography>
      </Box>
    </Box>
  );
  

  const content2 = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 2,
        }}
      >
        <Avatar
          component={RouterLink}
          src={user.avatar}
          sx={{
            cursor: "pointer",
            width: 64,
            height: 64,
          }}
          to="/app/profile"
        />
        <Typography color="#ffff" variant="h5">
          {user.name}
        </Typography>
        <Typography color="#ffff" variant="body2">
          {user.email}
        </Typography>
      </Box>

      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <div key={item.title}>
              <Typography
                color="white"
                variant="h6"
                style={{ paddingTop: "7px" }}
              >
                {item.title}
              </Typography>
              <Divider style={{ color: "white" }} />
              {item.children.map((child) => {
                return (
                  <li key={child.title} className="px-3 rounded-lg mb-1 text-gray-700">
                    {child.title === "LabList" ? (
                      <NavItemdropdown style={{ paddingTop: "3px" }} />
                    ) : child.title === "UserManagement" ? (
                      <UserManagementDropdown style={{ paddingTop: "3px" }} />
                    ) : child.title === "Assign Labs" ? (
                      <AssignLabDropdown style={{ paddingTop: "3px" }} />
                    ) : child.title === "Billing Information" ? (
                      <Billingdropdown style={{ paddingTop: "3px" }} />
                    ) : child.title === "Assessment" ? (
                      <AssessmentDropdown style={{ paddingTop: "3px" }} />
                    ) : (
                      <NavItem
                        href={child.href}
                        title={child.title}
                        icon={child.icon}
                        title1={item.title}
                        style={{ paddingTop: "3px" }}
                      />
                    )}
                  </li>
                );
              })}
            </div>
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      
      {/* Copyright Footer */}
      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          borderTop: '1px solid',
          borderColor: 'rgba(255, 255, 255, 0.12)'
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem'
          }}
        >
          © {new Date().getFullYear()} ZippyOPS Consulting Services LLP.
        </Typography>
      </Box>
    </Box>
  );

  return (
    <React.Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="right" // Corrected value
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
              top: 60,
              backgroundColor: "rgb(0, 30, 60)",
            },
          }}
        >
          {content2}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 60,
              height: "calc(100% - 64px)",
              backgroundColor: "rgb(0, 30, 60)",
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </React.Fragment>
  );
};

export default DashboardSidebar;
